import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { LucyAISection } from '../components/LucyAISection';
import {CheckCircle, MessageCircleDashed as MessageCircle, Clock, Shield, Zap, BookOpen, Globe, Award, Star, BookOpenCheck, Target, UserCheck, TrendingUp, BadgeCheck} from 'lucide-react';

export default function V2() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />

      {/* PRIMEIRA DOBRA - Hero Section com Formulário */}
      <section className="bg-gradient-to-br from-blue-900 via-blue-700 to-red-800 text-white py-4 md:py-8 relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-red-500 opacity-10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500 opacity-10 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/4 w-32 h-32 border-4 border-white opacity-5 rounded-lg rotate-12"></div>
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="flex flex-col items-center text-center space-y-4">
            
            {/* Logo */}
            <div className="flex justify-center">
              <img
                src="https://static.lumi.new/material/f5/f52798dbc620ddd6624930ad60efee25.png"
                alt="EW Pass Logo"
                className="h-20 md:h-24" />
            </div>

            {/* Conteúdo Principal */}
            <div className="space-y-3">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight">
                Comece inglês de verdade agora — <span className="text-yellow-300 pt-[12px] pb-[12px]">Grátis por 30 dias!</span>
              </h1>
              
              <p className="md:text-xl text-blue-50 leading-relaxed text-xl font-bold pt-[12px] pb-[12px]">
                Acesso completo ao EW PASS + IA Lucy 24h no Whatsapp + centenas de aulas!
                <br />
                Sem custo. Sem compromisso.
              </p>

              



              {/* Benefícios e CTA em duas colunas no desktop */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto items-start pt-[12px]">
                {/* Coluna Esquerda - Benefícios */}
                <div className="space-y-3">
                  <div className="flex items-start gap-3 justify-center md:justify-start">
                    <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                    <span className="text-base md:text-lg font-medium">+500 horas de aula de streaming</span>
                  </div>
                  <div className="flex items-start gap-3 justify-center md:justify-start">
                    <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                    <span className="text-base md:text-lg font-medium">Aulas no celular (aplicativo) ou PC</span>
                  </div>
                  <div className="flex items-start gap-3 justify-center md:justify-start">
                    <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                    <span className="text-base md:text-lg font-medium">Lucy IA pra praticar inglês no Whatsapp</span>
                  </div>
                  <div className="flex items-start gap-3 justify-center md:justify-start">
                    <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                    <span className="text-base md:text-lg font-medium">Aulas ao vivo toda semana</span>
                  </div>
                  <div className="flex items-start gap-3 justify-center md:justify-start">
                    <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                    <span className="text-base md:text-lg font-medium">Suporte com professores reais</span>
                  </div>
                </div>

                {/* Coluna Direita - CTA Link (rola até o cadastro no final da página) */}
                <div className="w-full">
                  <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8 relative">
                    {/* Flag-inspired accent */}
                    <div className="absolute -top-2 -right-2 w-20 h-20 bg-gradient-to-br from-blue-600 to-red-600 rounded-full opacity-20 blur-xl"></div>
                    
                    <a
                      href="https://checkout.ewpass.com.br/subscribe/ewpass-trial-30d-49"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block w-full text-center bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-bold py-5 px-6 rounded-lg text-lg md:text-xl shadow-lg transition-all transform hover:scale-105">👉 Quero meus 30 dias grátis!
                    </a>

                    <div className="text-center space-y-1 text-sm text-gray-600 mt-4">
                      <p className="flex items-center justify-center gap-2">
                        <Clock className="w-4 h-4" />
                        Leva menos de 30 segundos
                      </p>
                      <p className="flex items-center justify-center gap-2">
                        <Shield className="w-4 h-4" />
                        Sem spam. Acesso liberado na hora.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* O QUE ACONTECE DEPOIS DO CADASTRO */}
      <section className="md:py-24 bg-white pt-[12px] pb-[12px]">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="md:text-4xl font-bold text-gray-900 text-center mb-12 text-4xl">O que acontece depois do cadastro

          </h2>

          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div className="space-y-3">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                <MessageCircle className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900">1. Acesso imediato</h3>
              <p className="text-gray-700">Receba a confirmação de cadastro no seu Whatsapp</p>
            </div>

            <div className="space-y-3">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
                <BookOpen className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900">2. Passo a passo</h3>
              <p className="text-gray-700">Siga o Passo a passo para começar a estudar na mesma hora</p>
            </div>

            <div className="space-y-3">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto">
                <Zap className="w-8 h-8 text-orange-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900">3. Plataforma liberada</h3>
              <p className="text-gray-700">Uso liberado da plataforma e da IA Lucy imediatamente</p>
            </div>
          </div>
        </div>
      </section>

      {/* SEGUNDA DOBRA - O Método EW */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white relative" style={{ backgroundImage: 'url(https://static.lumi.new/material/d7/d78ad0f9c576c520788494fc10e76f7f.png)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
        <div className="absolute inset-0 bg-white bg-opacity-90"></div>
        <div className="absolute top-10 right-10 text-9xl opacity-5">🇺🇸</div>
        <div className="absolute bottom-10 left-10 text-9xl opacity-5">🇬🇧</div>
        <div className="container mx-auto px-4 max-w-5xl relative z-10">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-12 text-blue-900 font-serif">
            O método EW é diferente porque:
          </h2>

          <div className="grid md:grid-cols-2 gap-5 md:gap-6 mb-12">
            {/* Card 1 - É estruturado (azul) */}
            <div className="bg-gray-50 rounded-2xl p-6 md:p-7 border-t-4 border-blue-700 shadow-sm hover:shadow-md transition-all">
              <div className="flex items-center gap-3 mb-3">
                <BookOpenCheck className="w-7 h-7 text-blue-900" />
                <h3 className="text-xl md:text-2xl font-bold text-blue-900">É estruturado</h3>
              </div>
              <p className="text-gray-600 text-base md:text-lg">Você sabe exatamente o que estudar</p>
            </div>

            {/* Card 2 - É prático (vermelho) */}
            <div className="bg-gray-50 rounded-2xl p-6 md:p-7 border-t-4 border-red-600 shadow-sm hover:shadow-md transition-all">
              <div className="flex items-center gap-3 mb-3">
                <Target className="w-7 h-7 text-blue-900" />
                <h3 className="text-xl md:text-2xl font-bold text-blue-900">É prático</h3>
              </div>
              <p className="text-gray-600 text-base md:text-lg">Você fala desde a primeira semana</p>
            </div>

            {/* Card 3 - É acompanhado (azul) */}
            <div className="bg-gray-50 rounded-2xl p-6 md:p-7 border-t-4 border-blue-700 shadow-sm hover:shadow-md transition-all">
              <div className="flex items-center gap-3 mb-3">
                <UserCheck className="w-7 h-7 text-blue-900" />
                <h3 className="text-xl md:text-2xl font-bold text-blue-900">É acompanhado por professores reais</h3>
              </div>
              <p className="text-gray-600 text-base md:text-lg">Não é você sozinho contra a plataforma</p>
            </div>

            {/* Card 4 - É progressivo (vermelho) */}
            <div className="bg-gray-50 rounded-2xl p-6 md:p-7 border-t-4 border-red-600 shadow-sm hover:shadow-md transition-all">
              <div className="flex items-center gap-3 mb-3">
                <TrendingUp className="w-7 h-7 text-blue-900" />
                <h3 className="text-xl md:text-2xl font-bold text-blue-900">É progressivo</h3>
              </div>
              <p className="text-gray-600 text-base md:text-lg">Cada aula constrói a próxima</p>
            </div>

            {/* Card 5 - É validado (azul) - ocupa largura total em desktop */}
            <div className="bg-gray-50 rounded-2xl p-6 md:p-7 border-t-4 border-blue-700 shadow-sm hover:shadow-md transition-all md:col-span-2">
              <div className="flex items-center gap-3 mb-3">
                <BadgeCheck className="w-7 h-7 text-blue-900" />
                <h3 className="text-xl md:text-2xl font-bold text-blue-900">É validado</h3>
              </div>
              <p className="text-gray-600 text-base md:text-lg">Por mais de 10.000 alunos</p>
            </div>
          </div>

          {/* Texto final */}
          <div className="text-center space-y-2 text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
            <p>Você não fica perdido.</p>
            <p>Você não fica pulando conteúdo.</p>
            <p className="font-bold text-blue-900 pt-2">Você segue um caminho claro.</p>
            <p className="font-bold text-red-600 text-xl md:text-2xl">E isso muda tudo.</p>
          </div>
        </div>
      </section>

      {/* BENEFÍCIOS CLAROS */}
      <section className="md:py-24 bg-white relative overflow-hidden pt-[12px] pb-[12px]">
        <div className="absolute top-20 -right-20 w-72 h-72 bg-gradient-to-br from-blue-500 to-red-500 opacity-5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 -left-20 w-72 h-72 bg-gradient-to-br from-red-500 to-blue-500 opacity-5 rounded-full blur-3xl"></div>
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="md:text-4xl font-bold text-gray-900 text-center mb-[48px] text-4xl">O que você tem acesso no teste grátis

          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 relative z-10">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 space-y-3 border-2 border-blue-200 hover:shadow-lg transition-all relative overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <img
                  src="https://static.lumi.new/b6/b6dc3cfb898f2627257b12a9dcabb43e.png"
                  alt="Plataforma EW Pass"
                  className="w-full h-full object-cover" />
              </div>
              <Award className="w-12 h-12 text-blue-600 relative z-10" />
              <h3 className="text-xl font-bold text-gray-900 relative z-10">Acesso completo ao EW Pass Pro</h3>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6 space-y-3 border-2 border-green-200 hover:shadow-lg transition-all relative overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <img
                  src="https://static.lumi.new/6d/6dd4228b67c7f28d6d0411213816e595.png"
                  alt="Lucy IA em ação"
                  className="w-full h-full object-cover" />

              </div>
              <MessageCircle className="w-12 h-12 text-green-600 relative z-10" />
              <h3 className="text-xl font-bold text-gray-900 relative z-10">IA Lucy disponível 24h para prática no Whatsapp</h3>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-6 space-y-3 border-2 border-orange-200 hover:shadow-lg transition-all relative overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <img
                  src="https://static.lumi.new/f8/f8412bd447c13ac6bcf1c1245b4d520a.png"
                  alt="Aulas práticas"
                  className="w-full h-full object-cover" />
              </div>
              <BookOpen className="w-12 h-12 text-orange-600 relative z-10" />
              <h3 className="text-xl font-bold text-gray-900 relative z-10">Aulas Ao Vivo toda semana</h3>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6 space-y-3 border-2 border-purple-200 hover:shadow-lg transition-all relative overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <img
                  src="https://static.lumi.new/1d/1df3e594d0bcbc542554333af3060d41.png"
                  alt="Estudo flexível"
                  className="w-full h-full object-cover" />
              </div>
              <Globe className="w-12 h-12 text-purple-600 relative z-10" />
              <h3 className="text-xl font-bold text-gray-900 relative z-10">Estudo pelo celular ou computador</h3>
            </div>

            <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl p-6 space-y-3 border-2 border-indigo-200 hover:shadow-lg transition-all relative overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <img
                  src="https://static.lumi.new/30/30c0f18cdcdce241f1d911390ed5b321.png"
                  alt="Método validado"
                  className="w-full h-full object-cover" />
              </div>
              <CheckCircle className="w-12 h-12 text-indigo-600 relative z-10" />
              <h3 className="text-xl font-bold text-gray-900 relative z-10">Método validado para quem já tentou aprender antes</h3>
            </div>

            <div className="bg-pink-50 rounded-xl p-6 space-y-3 border-2 border-pink-200 hover:shadow-lg transition-all relative overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <img
                  src="https://static.lumi.new/4b/4b0652656a2532d915b8c7de5b1cb4cc.png"
                  alt="Professores reais"
                  className="w-full h-full object-cover" />
              </div>
              <Clock className="w-12 h-12 text-pink-600 relative z-10" />
              <h3 className="text-xl font-bold text-gray-900 relative z-10">Suporte com professores reais</h3>
            </div>
          </div>
        </div>
      </section>

      {/* SEÇÃO LUCY IA */}
      <LucyAISection />

      {/* PROVAS SOCIAIS - Depoimentos */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50 relative">
        <div className="absolute inset-0 opacity-5 text-[#000000] bg-[#000000]" style={{ backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, #dc2626 35px, #dc2626 70px, transparent 70px, transparent 105px, #1e40af 105px, #1e40af 140px)' }}></div>
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12">
            O que quem já testou está dizendo
          </h2>

          <div className="grid md:grid-cols-2 gap-6 relative z-10">
            <div className="bg-white rounded-xl shadow-md p-6 space-y-3 border-l-4 border-blue-600 hover:shadow-xl transition-all">
              <div className="flex gap-1 text-yellow-400">
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
              </div>
              <p className="text-gray-700 italic">
                "Eu já tinha feito vários cursos e sempre desistia. Aqui consegui estudar 20 minutos por dia e finalmente destravei o inglês no trabalho."
              </p>
              <p className="text-sm font-semibold text-gray-900">— Roberto, Analista de TI</p>
            </div>

            <div className="bg-white rounded-xl shadow-md p-6 space-y-3 border-l-4 border-blue-600 hover:shadow-xl transition-all">
              <div className="flex gap-1 text-yellow-400">
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
              </div>
              <p className="text-gray-700 italic">
                "A Lucy me ajudou a perder o medo de falar. Treino todos os dias e já consigo me comunicar bem melhor em reuniões com clientes."
              </p>
              <p className="text-sm font-semibold text-gray-900">— Mariana, Gerente Comercial</p>
            </div>

            <div className="bg-white rounded-xl shadow-md p-6 space-y-3 border-l-4 border-blue-600 hover:shadow-xl transition-all">
              <div className="flex gap-1 text-yellow-400">
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
              </div>
              <p className="text-gray-700 italic">
                "Achei que não ia conseguir por causa da correria, mas consegui encaixar nas minhas manhãs. Em 3 semanas já vi evolução."
              </p>
              <p className="text-sm font-semibold text-gray-900">— Carlos, Empreendedor</p>
            </div>

            <div className="bg-white rounded-xl shadow-md p-6 space-y-3 border-l-4 border-blue-600 hover:shadow-xl transition-all">
              <div className="flex gap-1 text-yellow-400">
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
                <Star className="w-5 h-5 fill-current" />
              </div>
              <p className="text-gray-700 italic">
                "Finalmente um curso que ensina inglês de verdade, não decoreba. Fiz minha primeira viagem internacional e me virei super bem!"
              </p>
              <p className="text-sm font-semibold text-gray-900">— Juliana, Designer</p>
            </div>
          </div>
        </div>
      </section>

      {/* PROVA DE MASSA */}
      <section className="py-16 md:py-24 bg-gradient-to-br from-blue-900 via-blue-800 to-red-900 text-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full opacity-10">
          <div className="absolute top-10 right-20 text-8xl">🎓</div>
          <div className="absolute bottom-10 left-20 text-8xl">🗽</div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-9xl">🇬🇧</div>
        </div>
        <div className="container mx-auto px-4 max-w-5xl text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8">
            Mais de 10.000 alunos já testaram
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-8 border-2 border-white border-opacity-20 hover:bg-opacity-20 transition-all">
              <div className="text-5xl md:text-6xl font-bold text-blue-300 mb-2">10.000+</div>
              <p className="text-xl text-blue-100">alunos já testaram</p>
            </div>
            
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-8 border-2 border-white border-opacity-20 hover:bg-opacity-20 transition-all">
              <div className="text-5xl md:text-6xl font-bold text-blue-300 mb-2">2.000.000+</div>
              <p className="text-xl text-blue-100">de horas de estudo acumuladas</p>
            </div>
          </div>

          <p className="text-xl md:text-2xl text-blue-100 leading-relaxed max-w-3xl mx-auto">
            Isso não é só mais um teste grátis. É um método validado por quem já tentou aprender inglês antes.
          </p>
        </div>
      </section>

      {/* CTA FINAL - Reforço */}
      <section id="cta-final" className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white relative scroll-mt-20">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-transparent to-red-50 opacity-30"></div>
        <div className="container mx-auto px-4 max-w-2xl">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-8">
            Pronto para destravar seu inglês?
          </h2>

          <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 border-2 border-blue-200 relative z-10">
            <a
              href="https://checkout.ewpass.com.br/subscribe/ewpass-trial-30d-49"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-center bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-bold py-5 px-6 rounded-lg text-lg md:text-xl shadow-lg transition-all transform hover:scale-105">👉 Quero meus 30 dias grátis!
            </a>

            <div className="mt-6 text-center space-y-2 text-gray-600">
              <p className="text-lg font-semibold">Sem pagamento. Sem compromisso. Cancelamento simples.</p>
              <p className="flex items-center justify-center gap-2">
                <Clock className="w-4 h-4" />
                Leva menos de 30 segundos
              </p>
              <p className="flex items-center justify-center gap-2">
                <Shield className="w-4 h-4" />
                Sem spam. Acesso liberado na hora.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>);

}